import { LogLevel } from "@azure/msal-browser";


/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {

        //Local Ids
        //clientId: "58c210dd-81e0-4a5e-a950-a98fd686f4bf",
        //authority: "https://login.microsoftonline.com/36da45f1-dd2c-4d1f-af13-5abe46b99921",
        //////////-------------------------UAT Url
        ////redirectUri: "https://instageo2ejourney.deloitte.com/",
        ////postLogoutRedirectUri: "https://instageo2ejourney.deloitte.com/",
        ////-------------------------------Development Url
        //redirectUri: "https://localhost:44463/",
        //postLogoutRedirectUri: "https://localhost:44463/",


        //Production Ids
        clientId: "d5a0e336-9552-478f-b749-f31a6d601329",
        authority: "https://login.microsoftonline.com/36da45f1-dd2c-4d1f-af13-5abe46b99921",
        redirectUri: "https://ino2ejourney.deloitte.com/",
        postLogoutRedirectUri: "https://ino2ejourney.deloitte.com/",
        // navigateToLoginRequestUrl: false,







    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read", "profile", "email"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me", //e.g. https://graph.microsoft.com/v1.0/me
    graphMePhotoEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value"
};
